<template>
    <div class="uk-width-5-6 overview">

        <div class="uk-card uk-card-default uk-card-body uk-text-large uk-text-left border-radius">
            Starttijd <br />
            <b> {{ assignmentStartTimeString }} </b> <br /> <br />

            Ordernummer <br />
            <b> {{ assignment.orderId }} </b> <br /> <br />

            Opdracht <br />
            <b> {{ assignment.description }} </b> <br /> <br />

            Klant <br />
            <b> {{ assignment.customer }} </b> <br /> <br />

            Registratie gestart <br />
            <b> {{ startedTimeString }} </b>
        </div>

        <div
            v-if="! falseEnd"
            class="uk-card uk-card-default uk-card-body uk-margin-large-top uk-margin-large-bottom uk-text-large uk-text-left comment"
            :disabled="processing"
        >
            <textarea v-model="endComment" class="uk-textarea comment" />
        </div>

        <div
            v-if="falseEnd"
            class="uk-card uk-card-default uk-card-body uk-margin-large-top uk-margin-large-bottom uk-text-large border-radius false-end-message"
        >
            Voer minimaal 3 tekens in om registratie te kunnen stoppen
        </div>

        <div
            v-if="! falseEnd"
            :class="getEndButtonClasses()"
            @click="stopAssignmentRegistration"
        >
            STOP REGISTRATIE
        </div>

        <div
            v-if="falseEnd"
            class="uk-card uk-card-default uk-card-body uk-margin-large-bottom uk-text-large button button-enabled"
            @click="undoFalseEnd"
        >
            Begrepen
        </div>

        <div
            v-if="processing"
            class="uk-width-auto uk-margin-auto"
        >
            <span uk-spinner="ratio: 2" />
        </div>
    </div>
</template>

<style scoped>
    .overview {
        margin: 0 auto;
        text-align: center;
    }

    .border-radius {
        border-radius: 25px;
    }

    .comment {
        border-radius: 25px;
        min-height:    300px;
    }

    .button {
        color: white;
        font-weight: bold;
        border-radius: 500px;
        margin-bottom: 50px;
    }

    .button-enabled {
        background-color: limegreen;
        cursor: pointer;
    }

    .end-button-disabled {
        background-color: #d8d7d7;
    }

    .false-end-message {
        color: white;
        font-weight: bold;
        background-color: lightsalmon;
    }

</style>

<script>
import moment from 'moment';
import axios from 'axios';
import _ from 'lodash';

export default {
    name: "StartedAssignment",

    props: {
        assignment: {
            type: Object,
            default: () => {},
        },
        registration: {
            type: Object,
            default: () => {},
        },
        token: {
            type: String,
            default: () => '',
        },
        constants: { type: Object, required: true },
    },

    data() {
        return {
            processing:       false,
            endComment:       '',
            falseEnd:         false,
        }
    },

    computed: {
        startedTimeString() {
            let startMoment = moment.parseZone(this.registration.startTime, moment.ISO_8601);
            return startMoment.format('DD-MM-YYYY HH:mm');
        },

        assignmentStartTimeString() {
            let startMoment   = moment.parseZone(this.assignment.startsAt, moment.ISO_8601);
            return startMoment.format('DD-MM-YYYY HH:mm');
        },
    },

    methods: {
        getEndButtonClasses() {
            return 'uk-card uk-card-default uk-card-body uk-margin-large-bottom uk-text-large button '
                + ((this.mayStopRegistration()) ? 'button-enabled' : 'end-button-disabled')
            ;
        },

        mayStopRegistration() {
            if (this.endComment.length >= 3) {
                return true;
            }

            return false;
        },

        async stopAssignmentRegistrationCall() {
            try {
                let response = await axios.get(
                    '/timeRegistration.php',
                    {
                        params: {
                            action:       'stopRegistration',
                            token:        this.token,
                            registration: this.registration.id,
                            comment:      this.registration.comment,
                            activity:     this.constants.STOP_ACTIVITY_ID,
                        },
                    },
                );

                this.$emit('stop-assignment', response.data.data)
            } catch (e) {
                this.$emit('error', 'Fout opgetreden, registratie kon niet worden gestopt');
            }
        },

        stopAssignmentRegistration() {
            if (this.mayStopRegistration() && ! this.processing) {
                this.processing = true;
                this.getLocationData();
            } else if (! this.mayStopRegistration()) {
                this.falseEnd = true;
            }
        },

        getLocationData() {
            navigator.geolocation.getCurrentPosition(this.generateGoogleMapsLink, this.setEndComment, { timeout: 5000 });
        },

        setEndComment() {
            let div         = document.createElement('div');
            div.textContent = this.endComment;

            if (this.registration.comment.length > 0) {
                this.registration.comment += '\n<br />\n';
            }
            this.registration.comment += div.innerHTML;

            this.stopAssignmentRegistrationCall();
        },

        generateGoogleMapsLink(position) {
            let coordinates = position.coords;

            if (_.isNumber(coordinates.latitude) && _.isNumber(coordinates.longitude)) {
                // Save to assume we got valid location data, generate Google Maps link
                let googleMapsString = this.constants.GOOGLE_MAPS_URL + coordinates.latitude + ',' + coordinates.longitude;

                if (this.registration.comment.length > 0) {
                    this.registration.comment += '\n<br />\n';
                }

                this.registration.comment += '<a target="_blank" href="' + googleMapsString + '">Eindlocatie</a>';
            }

            this.setEndComment()
        },

        undoFalseEnd() {
            this.falseEnd = false;
        },
    }
}
</script>
